'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProvideProps2 = require('./ProvideProps');

var _ProvideProps3 = _interopRequireDefault(_ProvideProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Working = function (_ProvideProps) {
  (0, _inherits3.default)(Working, _ProvideProps);

  function Working() {
    (0, _classCallCheck3.default)(this, Working);
    return (0, _possibleConstructorReturn3.default)(this, _ProvideProps.apply(this, arguments));
  }

  Working.prototype.componentDidMount = function componentDidMount() {
    var form = this.getForm();
    form.registerChild(this);
  };

  Working.prototype.componentWillUnmount = function componentWillUnmount() {
    var form = this.getForm();
    form.unregisterChild(this);
  };

  Working.prototype.originalValueChanged = function originalValueChanged() {
    var form = this.getForm();

    this.setState({
      isWorking: form.isWorking()
    });
  };

  Working.prototype.renderEmptyChildren = function renderEmptyChildren(_ref) {
    var isWorking = _ref.isWorking;

    return _react2.default.createElement(
      'span',
      null,
      isWorking ? 'working' : 'idle'
    );
  };

  Working.prototype.getProps = function getProps() {
    return {
      isWorking: this.state.isWorking
    };
  };

  return Working;
}(_ProvideProps3.default);

exports.default = Working;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Working.js
 ** module id = 1285
 ** module chunks = 0
 **/